export default "__VITE_ASSET__Cl6tBE9___"